<template>
  <div class="card">
    <form id="transactionForm" class="form-horizontal">
      <div class="card-header">
        <h4 class="card-title">
          Transaction Form
        </h4>
      </div>
      <div class="card-content">
        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Type</label>
            <div class="col-sm-6">
              <el-select class="select-primary"
                           name="transactionType"
                           data-vv-as="Transaction Type"
                           size="large"
                           placeholder="Choose One"
                           v-validate="modelValidations.transactionType"
                           v-model="model.transactionType">
                  <el-option v-for="option in selects.typeoftransaction"
                             class="select-danger"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              <small class="text-danger" v-show="transactionType.invalid">
                {{ getError('transactionType') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Amount</label>
            <div class="col-sm-6">
              <input type="number"
                     name="amount"
                     data-vv-as="Amount"
                     v-validate="modelValidations.amount"
                     v-model="model.amount"
                     class="form-control">
              <small class="text-danger" v-show="amount.invalid">
                {{ getError('amount') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Description</label>
            <div class="col-sm-6">
              <input type="text"
                     name="description"
                     data-vv-as="Description"
                     v-validate="modelValidations.description"
                     v-model="model.description"
                     class="form-control">
              <small class="text-danger" v-show="description.invalid">
                {{ getError('description') }}
              </small>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <div class="form-group">
            <label class="col-sm-2 control-label">Date</label>
            <div class="col-sm-6">
              <el-date-picker
                name="transactionDate"
                data-vv-as="Transaction Date"
                v-validate="modelValidations.transactionDate"
                v-model="model.transactionDate"
                type="datetime"
                placeholder="Select date and time" 
                :picker-options="pickerOptions1"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd">
              </el-date-picker>
              <small class="text-danger" v-show="transactionDate.invalid">
                {{ getError('transactionDate') }}
              </small>
            </div>
          </div>
        </fieldset>


        <fieldset>
          <div class="form-group column-sizing">
            <label class="col-sm-2 control-label">
              Category
            </label>
            <div class="col-sm-6">
              <el-select class="select-primary"
                           name="category"
                           data-vv-as="Category"
                           size="large"
                           placeholder="Choose One"
                           v-validate="modelValidations.category"
                           v-model="model.category_id">
                  <el-option v-for="option in selects.userTransactionCategories"
                             class="select-primary"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              <small class="text-danger" v-show="category.invalid">
                {{ getError('category') }}
              </small>
              
            </div>
          </div>
        </fieldset>
      </div>
      <div class="card-footer">
        <p-button type="info" @click.prevent="validate" class="info" round>{{ model.saveTransactionButtonText }}</p-button>
      </div>
    </form>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker, TimePicker, Slider, Tag, Input, Button, Select, Option} from 'element-ui'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Option.name]: Option,
      [Select.name]: Select,
    },
    computed: {
      ...mapFields(['description', 'amount',  'transactionDate', 'transactionType', 'category'])
    },
    data () {
      return {
        model: {
          description: '',
          amount: '',
          category_id: '',
          transactionDate: '',
          transactionType: '',
          category: [],
          saveTransactionButtonText: 'Save Transaction'
        },
        modelValidations: {
          description: {
            required: true
          },
          amount: {
            required: true,
            decimal: true
          },
          transactionDate: {
            required: true,
          },
          transactionType: {
            required: true
          },
          category: {
            required: true,
          },
        },
        selects: {
          type: '',
          typeoftransaction: [{value: '1', label: 'Income'},
            {value: '2', label: 'Expense'},
            {value: '3', label: 'Lend'},
            {value: '4', label: 'Borrow'}],
          
          userTransactionCategories: [],
        },
        pickerOptions1: {
          shortcuts: [{
            text: 'Today',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: 'Yesterday',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: 'A week ago',
            onClick (picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        
        
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      enterPressed (e) {
        if(e.key == 'Enter') {
          this.validate()
        }
      },

      validate () {
        this.$validator.validateAll().then(isValid => {
          if(isValid){
            this.$emit('on-submit', this.model, isValid, this.$validator)
          }
        })
      },
      editViewCheck () {
       
        if(this.$route.name == 'Update Transaction'){

          this.$http.get('/transactions/' + this.$route.params.id)
          
          .then(response => {
            var transactionDetails = response.data

            this.model.amount = transactionDetails.amount
            this.model.description = transactionDetails.remark
            this.model.transactionDate = transactionDetails.transaction_date
            this.model.transactionType = transactionDetails.type_id
            this.model.category_id = transactionDetails.category_id
          
          })
          .catch(err => console.error(err))
        }
      },

      fetchCategories () {

        this.$http.get('/categories')
          
          .then(response => {
            let categories = response.data
            

            for(let key = 0; key < categories.length; key++) {

              let selectOption = new Object
              selectOption.value = categories[key]['id']
              selectOption.label = categories[key]['name']
              
              this.model.category[key] = selectOption
              
            }
            this.selects.userTransactionCategories = this.model.category
            
          })
          .catch(err => console.error(err))
        
      }
    },

    mounted () {
      this.editViewCheck()
    },

    async mounted () {
      this.fetchCategories ()
    },
    
    created: function () {
      window.addEventListener('keyup', this.enterPressed)
    },

    beforeDestroy () {
      window.removeEventListener('keyup', this.enterPressed)
    }
  }
</script>
<style>
  #transactionForm .el-select { display: block  !important;}
</style>